var exports = {
  "Y2": "FriendListItem.module__friendListItem___bGFfNF",
  "lY": "FriendListItem.module__contextMenuActive___bGFfNF",
  "Hb": "FriendListItem.module__friendInfo___bGFfNF",
  "HX": "FriendListItem.module__friendDetails___bGFfNF",
  "Um": "FriendListItem.module__friendNameRow___bGFfNF",
  "G3": "FriendListItem.module__friendName___bGFfNF",
  "tf": "FriendListItem.module__friendTag___bGFfNF",
  "kC": "FriendListItem.module__friendSubtext___bGFfNF",
  "MI": "FriendListItem.module__friendStatusOffline___bGFfNF",
  "wh": "FriendListItem.module__friendStatusOnline___bGFfNF",
  "yA": "FriendListItem.module__friendActions___bGFfNF",
  "I0": "FriendListItem.module__actionButtonMessage___bGFfNF",
  "cQ": "FriendListItem.module__actionButtonMore___bGFfNF",
  "nl": "FriendListItem.module__contextMenuButtonActive___bGFfNF",
  "TI": "FriendListItem.module__actionButtonAccept___bGFfNF",
  "Tl": "FriendListItem.module__actionButtonIgnore___bGFfNF",
  "P7": "FriendListItem.module__actionButtonCancel___bGFfNF",
  "RK": "FriendListItem.module__iconSize___bGFfNF",
};

module.exports = exports;
